export const validatorFnc = (value, range, message, t) => {
  if (value > range) {
    return Promise.reject(new Error(t(message)));
  }
  return Promise.resolve();
};
